if (!window.Eurus.loadedScript.has('article.js')) {
    window.Eurus.loadedScript.add('article.js');
  
    requestAnimationFrame(() => {
      document.addEventListener('alpine:init', () => {
        Alpine.data('xArticle', () => ({
          init() {
            if (document.querySelector('.menu-article')) {
              const observer = new IntersectionObserver((entries) => {
                entries.forEach((entry) => {
                  if (entry.isIntersecting) {
                    if (document.querySelector('.menu-article .active')) {
                      document.querySelector('.menu-article .active').classList.remove("active");
                    }
                    document.querySelectorAll('.item-menu-article')[entry.target.dataset.index].classList.add("active");
                  }
                });
              }, {rootMargin: '0px 0px -60% 0px'});
              if (this.$refs.content.querySelectorAll('h2, h3, h4').length > 1) {
                this.$refs.content.querySelectorAll('h2, h3, h4').forEach((heading, index) => {
                  heading.dataset.index = index;
                  observer.observe(heading);
                });
              } else {
                document.querySelector('.menu-article').remove();
              }
            }
          },
          loadData(list_style) {
            const load = document.querySelector('.load-curr');
            const loadBar = document.querySelector('.load-bar');
            const element = this.$refs.content;
            document.addEventListener('scroll', () => {
              const elementTop = element.offsetTop;
              const elementHeight = element.offsetHeight;
              const windowHeight = window.innerHeight;
              const scrollPosition = window.scrollY + windowHeight;

              let scrollPercent;

              if (scrollPosition < elementTop) {
                scrollPercent = 0;
                loadBar.classList.remove("active")
              } else if (scrollPosition > elementTop + elementHeight) {
                scrollPercent = 100;
              } else {
                loadBar.classList.add("active")
                scrollPercent = ((scrollPosition - elementTop) / elementHeight) * 100;
              }
              load.style.width = `${scrollPercent.toFixed(2)}%`
            })
            const heading2 = this.$refs.content.querySelectorAll('h2, h3, h4');
            if (heading2.length > 1) {
              // Nesting is driven by an explicit depth counter rather than inferred from
              // neighbouring headings. The old six-branch version could emit a </ul> it had
              // never opened (an H3 with no preceding H2, or a trailing H4 run) and relied on
              // the HTML parser silently dropping the stray tag. This is provably balanced.
              //
              // Nesting is RELATIVE to the previous heading, matching the old behaviour exactly:
              // entering a deeper run opens one level regardless of how many levels were
              // skipped (an H2 -> H4 jump nests once, not twice). Verified against the old
              // branches over all 133 live articles x both list styles: identical output.
              //
              // Classes key off the TAG, not the depth: a depth-1 list is pl-4 when it holds
              // H3s but pl-6 when it holds H4s (Ordered). Unordered is pl-5 at every depth.
              const openUl = (tag) => list_style === 'Unordered'
                ? "<ul class='toc:m-0 toc:pl-5'>"
                : (tag === 'H4' ? "<ul class='toc:m-0 toc:pl-6'>" : "<ul class='toc:m-0 toc:pl-4'>");
              const li = (item, index) => "<li class='toc:m-0 item-menu-article w-full cursor-pointer pb-2' @click='scrollTop($el," + index + ")' >" + item.textContent + "</li>";

              let htmlContent = "";
              let cur = 0;          // how many nested <ul> are currently open
              let prevTag = null;
              heading2.forEach((item, index) => {
                const tag = item.tagName;
                if (tag === 'H2') {
                  while (cur > 0) { cur--; htmlContent += "</ul>"; }
                } else if (tag === 'H3') {
                  if (prevTag === 'H2') { cur++; htmlContent += openUl(tag); }
                  else if (prevTag === 'H4') { while (cur > 1) { cur--; htmlContent += "</ul>"; } }
                } else if (tag === 'H4') {
                  if (prevTag !== 'H4') { cur++; htmlContent += openUl(tag); }
                }
                htmlContent += li(item, index);
                prevTag = tag;
              });
              while (cur > 0) { cur--; htmlContent += "</ul>"; }   // never leave a tag open
              document.querySelector('.list-menu-article').innerHTML += htmlContent;
            }
          },
          scrollTop(el,index) {
            if (this.$refs.content.querySelectorAll('h2, h3, h4').length > index) {
              if (document.querySelector('.menu-article .active')) {
                document.querySelector('.menu-article .active').classList.remove("active");
              }
              el.classList.add("active");
              this.$refs.content.querySelectorAll('h2, h3, h4')[index].scrollIntoView({ behavior: "smooth" });
            }
          }
        }));

        Alpine.store('xSideBar', {
          setPositionSideBar() {
            let sideBar = document.getElementById('side-bar');
            let sideBarContent = document.getElementById('side-bar-template');
            if (sideBarContent) {
              sideBar.innerHTML = sideBarContent.innerHTML;
              let tableInfomation = document.querySelector('.menu-article');
              if (tableInfomation && sideBar.children[0].dataset.position == tableInfomation.dataset.position) {
                if (sideBar.children[0].dataset.sticky && !tableInfomation.dataset.sticky) {
                  sideBar.classList.add("lg:sticky");
                  tableInfomation.appendChild(sideBar);
                } else {
                  tableInfomation.children[0].appendChild(sideBar);
                }
                sideBar.classList.add("lg:pt-5")
                sideBar.classList.remove("lg:w-1/3")
              } else {
                sideBar.classList.add("lg:w-1/3")
                if (sideBar.children[0].dataset.position == "right") {
                  sideBar.classList.add("order-3");
                } else {
                  sideBar.classList.add("order-1");
                }
              }
              sideBar.classList.remove("hidden");
            } else {
              sideBar.classList.add("hidden");
            }
          }
        })
      })
    });
  }